export const letterFrequencies = {
    de:
        [
            { key: "E", value: "19.8" },
            { key: "N", value: "10.0" },
            { key: "I", value: "7.6" },
            { key: "R", value: "7.2"},
            { key: "S", value: "6.9" },
            { key: "A", value: "6.4" },
            { key: "T", value: "5.9" },
            { key: "H", value: "5.2" },
            { key: "D", value: "5.1" },
            { key: "U", value: "4.3" }
        ],

        en:
        [
            { key: "E", value: "12.0" },
            { key: "T", value: "9.1" },
            { key: "A", value: "8.1" },
            { key: "O", value: "7.7"},
            { key: "I", value: "7.3" },
            { key: "N", value: "7.0" },
            { key: "S", value: "6.3" },
            { key: "R", value: "6.0" },
            { key: "H", value: "5.9" },
            { key: "D", value: "4.3" }
        ]

}

export const bigramFrequencies = {
    de:
        [
            { key: "ER", value: "9.9" },
            { key: "EN", value: "3.7" },
            { key: "CH", value: "3.0" },
            { key: "TE", value: "2.2"},
            { key: "ND", value: "2.1" },
            { key: "EI", value: "2.1" },
            { key: "DE", value: "2.1" }
        ],

    en:
        [
            { key: "TH", value: "1.5" },
            { key: "HE", value: "1.2" },
            { key: "IN", value: "0.9" },
            { key: "ER", value: "0.9"},
            { key: "AN", value: "0.8" },
            { key: "RE", value: "0.7" },
            { key: "ND", value: "0.6" }
        ]

}

export const trigramFrequencies = {
    de:
        [
            { key: "EIN", value: "1.1" },
            { key: "ICH", value: "1.1" },
            { key: "DER", value: "0.9" },
            { key: "SCH", value: "0.8"},
            { key: "UND", value: "0.8" },
            { key: "DIE", value: "0.7" },
            { key: "NDE", value: "0.7" }
        ],
    en:
        [
            { key: "THE", value: "1.8" },
            { key: "AND", value: "0.7" },
            { key: "ING", value: "0.7" },
            { key: "ENT", value: "0.4"},
            { key: "ION", value: "0.4" },
            { key: "HER", value: "0.4" },
            { key: "FOR", value: "0.3" }
        ]

}